import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import media from 'constants/styles/media';
import { SECTION_IDS } from 'constants/index';
import { Header } from 'components/header';
import { BodyText } from 'components/typography/bodyText';
import { Section } from 'components/layout/Section';
import { FUNCTION_SECTION_CARDS } from './constants/functionSectionCards';
import { FunctionCard } from './components/function-card';

const SWrapper = styled.div`
    text-align: left;
    align-self: flex-start;
    margin-bottom: 36px;
    max-width: 632px;
`;

const SGroupLabel = styled.p`
    font-weight: 500;
    font-size: 20px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    margin-bottom: 24px;
`;

const SGrid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 24px 36px;

    @media (max-width: ${media.tablet}) {
        grid-template-columns: 1fr;
        grid-gap: 24px;
    }
`;

const SGroup = styled.div`
    width: 100%;
    margin-top: 36px;
`;

export const FunctionSection = () => {
    const { t } = useTranslation();

    return (
        <Section id={SECTION_IDS.FUNCTIONS}>
            <SWrapper>
                <Header text={t('function-section.header')} />
                <BodyText>{t('function-section.description')}</BodyText>
            </SWrapper>

            <SGroup>
                <SGroupLabel>{t('function-section.groups.basic')}</SGroupLabel>
                <SGrid>
                    {FUNCTION_SECTION_CARDS.basic.map((c) => (
                        <FunctionCard
                            key={c.no}
                            no={c.no}
                            title={t(c.titleKey)}
                            description={t(c.descKey)}
                        />
                    ))}
                </SGrid>
            </SGroup>

            <SGroup>
                <SGroupLabel>{t('function-section.groups.premium')}</SGroupLabel>
                <SGrid>
                    {FUNCTION_SECTION_CARDS.premium.map((c) => (
                        <FunctionCard
                            key={c.no}
                            no={c.no}
                            title={t(c.titleKey)}
                            description={t(c.descKey)}
                            isPremium
                        />
                    ))}
                </SGrid>
            </SGroup>
        </Section>
    );
};
